angular.module('core')
  .controller('DblPrintAllStudentsModalController', [
        '$compile',
        '$modalInstance',
        '$q',
        '$scope',
        '$timeout',
        'astName',
        'cancelableResourceManager',
        'breadcrumbNames',
        'dblPrintAllStudentsModalService',
        'dblPrintService',
        'students',
        'studentOverviewOptions',
    function(
        $compile,
        $modalInstance,
        $q,
        $scope,
        $timeout,
        astName,
        cancelableResourceManager,
        breadcrumbNames,
        dblPrintAllStudentsModalService,
        dblPrintService,
        students,
        studentOverviewOptions
    ) {
    var BATCH_THRESHOLD = 30;
    var BATCH_SIZE = 25;
    var SELECT_REPORTS_TITLE = 'Select Which Reports to Print:';

    var childScope;
    var reportElement;

    var template = '<div class="all-student-overview-report">' +
            '<div ng-repeat="student in studentsInBatch" class="student-overview-report">' +
                '<img class="dreamboxLogo" src="/resources/images/logo.png" />' +
                '<div><span ng-repeat="breadcrumbName in breadcrumbNames track by $index">{{ breadcrumbName }} <span>&gt;</span> </span><span>{{ student.name }}</span></div>' +
                '<timeframe-label></timeframe-label>' +
                '<dbl-student-overview ' +
                    'dbl-student="student" ' +
                    'dbl-timeframe-observable="timeframeChange" ' +
                    'dbl-ast-name="astName" ' +
                    'dbl-on-done-rendering="studentRendered(studentId, errorMsg)"' +
                    'dbl-options="options"></dbl-student-overview>' +
            '</div>' +
        '</div>';

    $scope.students = students;
    $scope.astName = astName;
    $scope.breadcrumbNames = breadcrumbNames; // this goes down to the classroom
    $scope.options = studentOverviewOptions;
    $scope.timeframeChange = 1; // define this as anything to let the student overview know it can use the timeframe
    $scope.titleText = SELECT_REPORTS_TITLE;

    var exitPrintMode = function () {
        $scope.renderingDeferred = undefined;
        $scope.studentsInBatch = undefined;
        $scope.renderedCount = 0;
        $scope.titleText = SELECT_REPORTS_TITLE;
    };

    var enterPrintMode = function (studentsInBatch, titleText) {
        $scope.renderingDeferred = $q.defer();
        $scope.renderedCount = 0;
        $scope.studentsInBatch = studentsInBatch;
        $scope.titleText = titleText;
    };

    var cleanUpResources = function () {
        // clean up angular from previous print. Makes sure obsolete event handlers
        // are disconnected.
        if (childScope) {
            childScope.$destroy();
            childScope = undefined;
        }
        // clear out any previous print element
        dblPrintService.resetPrintSection();
    };

    var close = function () {
        cleanUpResources();

        $modalInstance.close();
    };

    $scope.buttonClicked = function() {
        if ($scope.renderingDeferred) {
            // We're in "print mode" so cancel printing and only close
            // dialog if job was not split into batches
            $scope.renderingDeferred.reject();
            exitPrintMode();

            // try to allow UI to update before canceling requests
            $timeout(function () {
                cancelableResourceManager.cancelAll();
            });

            if (!$scope.batches) {
                close();
            }
        } else {
            // We're in "selection mode" so close dialog
            close();
        }
    };

    $scope.print = function (studentsInBatch, batchName) {
        var titleText = 'Printing Student Overview Reports';
        if (batchName) {
            titleText = 'Preparing Reports for ' + batchName;
        }

        enterPrintMode(studentsInBatch, titleText);

        cleanUpResources();

        $scope.renderingDeferred.promise.then(function () {
            dblPrintService.printElement(reportElement);
            if ($scope.batches) {
                exitPrintMode();
            } else {
                close();
            }
        });

        childScope = $scope.$new();
        reportElement = $compile(template)(childScope);
    };

    $scope.studentRendered = function (studentId, errorMsg) {
        if (!$scope.renderingDeferred) {
            return;
        }

        $scope.renderedCount++;
        if ($scope.renderedCount === $scope.studentsInBatch.length) {
            // give the modal a chance to update before kicking off the browser print dialog
            $timeout(function () {
                $scope.renderingDeferred.resolve();
            });
        }
    };

    var createBatches = function () {
        var batchCount = Math.ceil(students.length / BATCH_SIZE);
        var batches = [];
        for (var i = 0; i < batchCount; i++) {
            var start = i * BATCH_SIZE;
            var end = Math.min(students.length, (i + 1) * BATCH_SIZE);
            var studentsInBatch = students.slice(start, end);
            var batch = {
                name: studentsInBatch[0].name + ' to ' + studentsInBatch[studentsInBatch.length - 1].name,
                students: studentsInBatch
            };

            batches.push(batch);
        }

        return batches;
    };

    $modalInstance.opened.then(function () {
        if (students.length > BATCH_THRESHOLD) {
            $scope.batches = createBatches();
        } else {
            // Just generate report.
            // Our version of ui bootstrap (0.12) doesn't support the 'rendered' promise on
            // $modalInstance so using timeout to make sure modal is visible before
            // we start generating the report.
            $timeout(function () {
                $scope.print(students);
            });
        }
    });

}]);
